import React from 'react';
import { customizable } from '@fluentui/react';

import { IButtonImplProps } from '../BaseButton.types';
import { DefaultButton } from '../DefaultButton';

@customizable('PillButton', ['theme', 'styles'], true)
export class PillButton extends React.Component<IButtonImplProps, Record<string, unknown>> {
  public render(): JSX.Element {
    return <DefaultButton {...this.props} />;
  }
}
